export default "__VITE_ASSET__3BZN$Lmc__"